module.exports = __webpack_public_path__ + "static/media/LINK-USDT.b7447f40.svg";